import {
  ActiveInactiveStatus,
  ApiListResponse,
  ApiTokenListResponse,
  SessionPackDTO,
  SessionPackSummaryDTO,
  SubscriptionSessionPackDTO,
  SubscriptionSessionPackUsageHistoryDTO,
} from "@gymflow/types";
import { AxiosInstance } from "axios";
import QueryString from "qs";

export type CustomerCreditPackApiType = ReturnType<
  typeof customerCreditPackApi
>;

const customerCreditPackApi = (
  axiosInstance: AxiosInstance,
  clubId: number,
) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    getById(id: number) {
      return axiosInstance.get<SessionPackDTO>(
        `${clubPrefix}customer/sessionpack/${id}`,
      );
    },
    summary(params: { sessionPackId: number; promotionCode?: string }) {
      return axiosInstance.post<SessionPackSummaryDTO>(
        `${clubPrefix}customer/sessionpack/summary`,
        params,
      );
    },
    getList(params: {
      status?: ActiveInactiveStatus;
      id?: number[];
      hasActivityCategory?: boolean;
      hasAppointableCategory?: boolean;
      page: number;
      size: number;
      sort?: string;
    }) {
      return axiosInstance.get<ApiListResponse<SessionPackDTO>>(
        `${clubPrefix}customer/sessionpack`,
        {
          params,
        },
      );
    },
    sessionPackSubscriptionCurrent({
      nextPageToken,
    }: {
      nextPageToken?: string;
    }) {
      return axiosInstance.get<
        ApiTokenListResponse<SubscriptionSessionPackDTO>
      >(
        `${clubPrefix}customer/session-pack-subscription/current?${QueryString.stringify(
          { nextPageToken, limit: 20 },
        )}`,
      );
    },
    sessionPackSubscriptionPrevious({
      nextPageToken,
    }: {
      nextPageToken?: string;
    }) {
      return axiosInstance.get<
        ApiTokenListResponse<SubscriptionSessionPackDTO>
      >(
        `${clubPrefix}customer/session-pack-subscription/previous?${QueryString.stringify(
          { nextPageToken, limit: 20 },
        )}`,
      );
    },
    sessionPackSubscriptionUsageHistory({
      subscriptionId,
      nextPageToken,
    }: {
      subscriptionId: number;
      nextPageToken?: string;
    }) {
      return axiosInstance.get<
        ApiTokenListResponse<SubscriptionSessionPackUsageHistoryDTO>
      >(
        `${clubPrefix}customer/session-pack-subscription/${subscriptionId}/usage-history?${QueryString.stringify(
          { nextPageToken, limit: 20 },
        )}`,
      );
    },
  };
};

export default customerCreditPackApi;
